import React from 'react';

export interface AddressSecondaryTextProps
  extends React.HTMLProps<HTMLDivElement> {
  text: string;
}

const AddressSecondaryText: React.FC<AddressSecondaryTextProps> = ({
  text,
  ...props
}) => (
  <div
    className={`font-regular text-[1.4rem] leading-[1.7rem] text-[#818181] mt-[0.2rem] ${props.className || ''}`}
    {...props}
  >
    {text}
  </div>
);

export default AddressSecondaryText;
